<template>
  <div class="BasicLayout-header u-flex u-row-between">
    <div class="web-info">
      <a style="text-decoration: none;" :href="`/${lang}/home`">
        <img v-if="isLargeScreen" :src="getLogoUrl()" alt="{{ t('meta.title') }}" />
      </a>
    </div>
    <div class="web-user-info-box">
      <a class="token" style="text-decoration: none;" :href="`/${lang}/writingSkill`">
        <span>{{t('header.span10')}}</span>
      </a>

      <!-- Only display on large screens -->
      <div v-if="isLargeScreen" class="token">
        <img :src="tokenImg" alt="">
        <span>{{t('header.span1')}}（{{ userInfo.availableCredit || 0 }}）</span>
      </div>
      <div v-if="isLargeScreen" style="text-decoration: none;" @click="inspectLogin('token')"  class="shop">
        <img :src="shop" alt="">
        <span>{{t('header.span2')}}</span>
      </div>
      <div v-if="isLargeScreen" style="text-decoration: none;" @click="inspectLogin('invite')" class="invite">
        <img :src="invite" alt="">
        <span>{{t('header.span3')}}</span>
      </div>

      <!-- User info displayed if logged in -->
      <div v-if="token && isLargeScreen" class="web-user-info" >
        <img class="avatar" :src="avatar" alt="">
        <img class="down" :src="down" alt="">
        <div class="menu-box">
          <div class="menu">
            <div class="menu-item" @click="router.push({path:`/${lang}/dashboard`})">
              <menu1 class="svg" />
              <span>{{t('header.span4')}}</span>
            </div>
            <div class="menu-item" @click="store.isToken(true)">
              <menu2 class="svg" />
              <span>{{t('header.span5')}}</span>
            </div>
            <div class="menu-item" :class="showAboutUs?'active':''" @click="store.isAboutUs(true)">
              <menu3 class="svg" />
              <span>{{t('header.span6')}}</span>
            </div>
            <div class="menu-item" :class="showAboutUs?'active':''" @click="logout">
              <menu3 class="svg" />
              <span>{{t('header.span7')}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- No login info -->
      <div v-if="!token && isLargeScreen" class="no-login">
        <span style="text-decoration: none;" @click="store.isLogin(true)">
          <span>{{t('header.span8')}}</span>
        </span>
        <span class="vertical"></span>
        <span style="text-decoration: none;" @click="store.isRegister(true)">
          <span>{{t('header.span9')}}</span>
        </span>
      </div>


      <!-- Guide to PC version -->
      <div v-if="!isLargeScreen" class="pc-redirect">
        <p>访问PC端,解锁作文批改，思路扩展等更多功能。<a href="https://m.xzlink.com">点击打开</a></p>
      </div>
    </div>
  </div>
</template>

<script setup>
  const lang = getInitialLanguage();
  import { ElMessageBox } from 'element-plus'

  import { useRouter,useRoute } from 'vue-router';
  import { useAppStore } from "@/store";
  // import logo from `../../assets/header/logo.${lang}.png`

  const getLogoUrl = () => {
    return new URL(`../../assets/header/logo.${lang}.png`, import.meta.url).href
  }
  import tokenImg from '../../assets/header/token.png'
  import shop from '../../assets/header/shop.png'
  import invite from '../../assets/header/invite.png'
  import avatar from '../../assets/header/avatar.png'
  import down from '../../assets/header/down.png'
  import menu1 from '../../assets/header/menu1.svg'
  import menu2 from '../../assets/header/menu2.svg'
  import menu3 from '../../assets/header/menu3.svg'
  import { getInitialLanguage, setLanguage } from '../../utils/language';
  import i18n from '../../locale/i18n';
  const t = (key) => i18n.global.t(key);
  import { useWeChatShare } from "../../components/useWeChatShare.js";
  import { isWeChatBrowser } from "../../utils/isWeChat";
  import { getOpenIdByCode } from "@/api/api";

  const router = useRouter();
  const route = useRoute();
  const store = useAppStore();

  const showAboutUs = ref(store.showAboutUs);
  const token = ref(store.token);
  const userInfo = ref(store.userInfo);

  // Check if it's a large screen (default is desktop version)
  const isLargeScreen = ref(true);
  if (typeof window !== 'undefined') {
    isLargeScreen.value = window.innerWidth > 768;
    // Watch for screen size change
    window.addEventListener('resize', () => {
      isLargeScreen.value = window.innerWidth > 768;
    });

    if (isWeChatBrowser()) {
      console.log("当前是微信浏览器，执行分享代码");
      onMounted(async () => {
        const shareData = {
          title: document.title,  // 读取 <title>
          desc: document.querySelector('meta[name="description"]')?.content || '默认描述',
          link: "",
          imgUrl: "https://www.xzlink.com/favicon.ico"
        };
        const currentUrl = window.location.href.split('#')[0];
        shareData.link = currentUrl;
        console.log('获取到的 shareData：', shareData);
        const code = route.query.code;
        console.log('获取到的 code：', code);
        if(code){
          const res = await getOpenIdByCode({code:code});
        }
        //else{
        //  const redirectUri = window.location.href.split('?')[0];
        //  window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx43c499b66a873c90&redirect_uri="+redirectUri+"&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
        //}
        const { initWeChatShare } = useWeChatShare(shareData);
        initWeChatShare();
      })
    } else {
      console.log("当前不是微信浏览器，不执行分享代码");
    }
  }

  const inspectLogin = (type) => {
    if(token.value) {
      if(type == 'token') {
        store.isToken(true)
      }
      if(type == 'invite') {
        store.isInvite(true)
      }
    } else {
      store.isLogin(true)
    }
  }

  const logout = () => {
    ElMessageBox.alert(t('header.message1'), t('header.message2'), {
      showCancelButton: true,
      callback: (e) => {
        if(e == 'confirm') {
          store.logout()
          window.location.href = `/${lang.value}/`;
        }
      },
    })
  }

</script>

<style lang="less" scoped>
  .BasicLayout-header {
    width: 100%;
    height: 4.36vw;
    padding: 0vw 2.6vw 0 11.2vw;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 90;
    min-height: 60px;

    .web-info {
      img {
        cursor: pointer;
        width: auto;
        height: 3vw;
      }
    }

    .token,
    .shop,
    .invite {
      cursor: pointer;
      display: flex;
      align-items: center;
      font-size: 1.04vw;
      font-weight: 900;
      color: rgba(56, 112, 255, 1);
      img {
        margin-right: 0.52vw;
        height: auto;
        display: block;
      }
    }

    .token {
      margin-right: 1.74vw;
      img {
        width: 0.99vw;
      }
    }

    .shop {
      margin-right: 2.43vw;
      img {
        width: 0.83vw;
      }
    }

    .invite {
      margin-right: 2.5vw;
      img {
        width: 0.78vw;
      }
    }

    .web-user-info-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .web-user-info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      cursor: pointer;
      &:hover {
        .menu-box {
          display: block;
        }
      }

      .avatar {
        width: 3.13vw;
        height: auto;
        margin-right: 1.04vw;
      }

      .down {
        width: 0.4vw;
        height: auto;
      }

      .menu-box {
        display: none;
        position: absolute;
        left: -3.33vw;
        bottom: 0;
        transform: translateY(100%);
        padding-top: 5px;
        .menu {
          width: 9.79vw;
          border-radius: 0.52vw;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0vw 0.1vw 1.3vw  rgba(156, 156, 156, 0.25);
          overflow-x: hidden;
          .menu-item {
            cursor: pointer;
            padding: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 0.83vw;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            .svg {
              width: 0.69vw;
              height: auto;
              margin-right: 0.35vw;
            }
          }
          .menu-item:hover,
          .active {
            background: rgba(247, 247, 247, 1);
            color: rgba(56, 112, 255, 1);
          }
        }
      }
    }

    .no-login {
      font-size: 1.04vw;
      font-weight: 900;
      color: rgba(56, 112, 255, 1);
      span {
        cursor: pointer;
      }
      .vertical {
        display: inline-block;
        width: 0;
        height: 1.04vw;
        border: 0.05vw solid rgba(56, 112, 255, 1);
        margin: 0 1vw;
      }
    }

    /* Small screen adjustments */
    @media screen and (max-width: 768px) {
      .web-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          display: none; /* Hide logo on small screens */
        }
      }

      .token,
      .shop,
      .invite,
      .web-user-info {
        display: none; /* Hide token, shop, invite, and user info on small screens */
      }

      .wechat-share {
        display: block;
        text-align: center;
      }

      .pc-redirect {
        display: block;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
</style>
